import { render, staticRenderFns } from "./PDPCommentModal.vue?vue&type=template&id=7b21829b&scoped=true&"
import script from "./PDPCommentModal.vue?vue&type=script&lang=js&"
export * from "./PDPCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentModal.vue?vue&type=style&index=0&id=7b21829b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21829b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
